import ModuleSectionV4 from './ModuleSectionV4';
import VideoClip from '../../common/container/VideoClip';
import {IVideoModuleV4} from '../type';

interface IProps {
  data: IVideoModuleV4;
}

export default function VideoModuleV4({data}: IProps) {
  const {section, videoInfo} = data;

  return (
    <ModuleSectionV4 data-module-type={data.moduleType} section={section}>
      <VideoClip
        video={videoInfo}
        isStreaming={videoInfo.isStreaming}
        isLazy={false}
        className="rounded-12 overflow-hidden"
      />
    </ModuleSectionV4>
  );
}
